module.exports = __webpack_public_path__ + "img/Xaas.439b9b1.svg";